import { render } from "./ImageDisplayDialog.vue?vue&type=template&id=b1c0db86"
import script from "./ImageDisplayDialog.vue?vue&type=script&lang=js"
export * from "./ImageDisplayDialog.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andreaskura/repos/cio-online-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__